import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { CommonModule } from "@angular/common";
import {
  PasswordStrengthValidatorComponent
} from "../../../../common/password-strength-validator/password-strength-validator.component";
import { AuthenticationService } from "../../../../domain/services/auth/authentication.service";
import { Router, RouterLink } from "@angular/router";
import { ToasterService } from "../../../../common/toaster/toaster.service";
import { passwordMatchValidator } from '../../../../utils/mustMatchValidators';


@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatButtonModule,
    PasswordStrengthValidatorComponent,
    RouterLink
  ],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.css'
})
export class ChangePasswordComponent implements OnInit {
  hide = true;
  hideC = true;
  strongPassword = false;
  working = false;
  signupForm = new FormGroup({
    password: new FormControl('', [
      Validators.minLength(8),
      Validators.required,
    ]),
    confirmPassword: new FormControl('', [
      Validators.minLength(8),
      Validators.required,
    ]),
  }, { validators: passwordMatchValidator('password', 'confirmPassword') });
  private email: string | undefined;

  constructor(private readonly authService: AuthenticationService,
    private readonly router: Router,
    private readonly toasterService: ToasterService,) {
  }

  get f() {
    return this.signupForm.controls;
  }

  get passwordMismatch() {
    let confirmPassword = this.signupForm.get('confirmPassword')?.value ?? '';
    return this.signupForm.hasError('passwordMismatch') && (confirmPassword.length > 0);
  }

  ngOnInit(): void {
    this.email = this.authService.getEmailToReset();
    if (!this.email) {
      this.router.navigate(['auth/login']);
    }
  }

  onPasswordStrengthChanged(event: boolean) {
    this.strongPassword = event;
  }

  changePassword() {
    const newPassword = this.f.password.value;
    if (newPassword) {
      this.authService.changePassword(this.email, newPassword).subscribe(value => {
        this.toasterService.show('success', 'Password was changed successfully', 'Your password was updated');
        this.router.navigate(['auth/login']);
      }, error => {
        this.toasterService.show('error', 'Password change failed', 'An error occurred while changing your password');
      })
    }
  }

}
